import React, { useEffect, useRef, useState } from "react";

import { CgAttachment } from "react-icons/cg";
import EmptyChat from "./EmptyChat";
import Messages from "./Messages";
import { Alert, Progress } from "antd";
import Attachment from "./Attachment";
import chatApi from "../../features/chat/api";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import { useParams } from "react-router-dom";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
const url = process.env.REACT_APP_ADMIN_URL;

export default function Conversation() {
  const conversationData = useSelector((state) => state.chat.conversationData);
  const profileData = useSelector((state) => state.chat.profileData);
  const authToken = useSelector((state) => state.auth.token);

  const chatcard = useRef(null);

  const userId = useParams()?.id;

  // const socket = io(url, {
  //   extraHeaders: {
  //     authorization: authToken,
  //   },
  //   reconnection: false,
  // });

  const [files, setFiles] = useState([]);
  const [messages, setMessages] = useState([]);
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [isError, setIsError] = useState(false);
  // const [connection, setConnection] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [subjectValue, setSubjectValue] = useState("");
  const [textValue, setTextValue] = useState("");
  const [readByTalent, setReadByTalent] = useState([]);

  // useEffect(() => {
  //   if (conversationData?.body && typeof conversationData?.body === "object") {
  //     setMessages(conversationData?.body);
  //     setConversationId(conversationData?.body?.[0]?.ConversationId);
  //   }

  //   if (chatcard.current !== null) {
  //     setTimeout(() => {
  //       chatcard.current.scrollTop = chatcard.current?.scrollHeight;
  //     }, 100);
  //   }

  // }, [conversationData]);

  // useEffect(() => {

  //   if (!connection) {
  //     // connect to socket
  //     socket.connect();
  //     setConnection(true);
  //   }

  //   // connect to socket
  //   socket.on("connect", () => {
  //     setConnection(true);
  //   });

  //   // listen for messages
  //   socket.on("message", (response) => {

  //     if (
  //       response?.data?.SenderProfileId == userId ||
  //       response?.data?.RecipientProfileId == userId
  //     ) {
  //       if (!conversationId) {
  //         setConversationId(response?.data?.ConversationId);
  //       }

  //       setMessages((prevMessages) => [...prevMessages, response?.data]);
  //       setTimeout(() => {
  //         chatcard.current.scrollTop = chatcard.current?.scrollHeight;
  //       }, 100);
  //     }
  //   });

  //   socket.on('connect_error', (err) => {
  //     console.log('Connection error:', err.message);
  //     if (err.response && err.response.status === 502) {
  //       socket.connect();
  //     }
  //     // socket.disconnect(); // This will now prevent further reconnection attempts
  //   });

  //   // listen for read by talent
  //   socket.on("messageStatusUpdate", (response) => {
  //     setReadByTalent((prevReadByTalent) => [...prevReadByTalent, response.MessageGUID]);
  //   });

  //   // disconnect from socket
  //   socket.on("disconnect", () => {
  //     setConnection(false);
  //   });

  //   return () => {
  //     socket.disconnect();
  //     setConversationId(null);
  //     setMessages([]);
  //   };
  // }, []);

  // remove file before send
  const removeFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  // send message by pressing enter
  const handleTextKeyPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      sendMessage();
    }
  };

  // upload and handle file
  const handleFileChange = async (event) => {
    for (let i = 0; i < event.target.files.length; i++) {
      // check if file already exists
      if (
        files.find((file) => file.inpFile.name === event.target.files[i].name)
      ) {
        return;
      }

      setIsUploading(true);
      setProgress(70);
      let payload = {
        type: "msgAttachment",
        contentType: event.target.files[i].type,
      };
      try {
        let response = await chatApi.fileUplaod(payload);

        if (response?.data) {
          setProgress(100);

          let fileData = {
            inpFile: event.target.files[i],
            fileKey: response.data.Key,
            fileUrl: response.data.uploadURL,
            FileName: event.target.files[i].name,
            FileSize: event.target.files[i].size,
            FilePath: response.data.Key,
          };
          setFiles((prevFiles) => [...prevFiles, fileData]);
          setIsUploading(false);
        }
      } catch (error) {
        setIsError(true);
      }
    }
  };

  // send message
  const sendMessage = async () => {
    if (!subjectValue && !textValue && files.length === 0) {
      return;
    }

    for (let i = 0; i < files.length; i++) {
      let uploadRequestS3 = null;
      try {
        if (files[i].fileUrl) {
          uploadRequestS3 = await axios.put(files[i].fileUrl, files[i].inpFile);
        }
      } catch (error) {
        console.log(error);
        setIsError(true);
      }

      if (!uploadRequestS3) {
        setIsError(true);
        return;
      }
    }

    if (isError) {
      return;
    }
    // if (!connection) {
    //   socket.connect();
    //   setConnection(true);
    // }

    const messageObj = {
      sender: "Admin",
      adminId: profileData?.data?.body?.user?.AccountId,
      talentId: userId,
      data: textValue ? textValue : null,
      subject: subjectValue ? subjectValue : null,
      conversationId: conversationId,
      Attachments: files.length > 0 ? files : null,
      HasAttachments: files.length > 0 ? true : false,
    };
    console.log(messageObj);
    // socket.emit("createMessage", messageObj);

    setSubjectValue("");
    setTextValue("");
    setFiles([]);
  };

  return (
    <>
      {conversationData ? (
        <Messages conversationData={messages} readByTalent={readByTalent} ref={chatcard} />
      ) : (
        <EmptyChat />
      )}
      <div
        style={{
          bottom: "5px",
          padding: "0% 1.5% 0% 1.5%",
          width: "100%",
          position: "relative",
          zIndex: "1",
          backgroundColor: "#fff",
        }}
        className={`send-message-container`}
      >
        <div
          className="text-with-attachment"
          style={{
            borderRadius: "0.25rem",
            boxShadow: "0 0 0.25rem 0 rgba(0, 0, 0, 0.25)",
          }}
        >
          <div>
            <textarea
              name=""
              id=""
              placeholder="Add a subject"
              className="teaxArea-content-subject ant-input"
              onChange={(e) => setSubjectValue(e.target.value)}
              value={subjectValue}
            ></textarea>
            <textarea
              name=""
              id=""
              placeholder="Type your message here..."
              className="teaxArea-content ant-input"
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
              onKeyDown={handleTextKeyPress}
            ></textarea>
          </div>
          <div className="attachment-box">
            {isError && (
              <Alert
                type="error"
                showIcon={false}
                message="Document failed to upload"
                banner
              />
            )}

            {isUploading && (
              <div className="upload-progress">
                <Progress percent={progress} status="active" size="small" />
              </div>
            )}
            {files?.map((file, key) => (
              <div className="attachment-container">
                <Attachment
                  fileName={file.inpFile.name}
                  filePath={file.fileUrl}
                  fileSize={file.inpFile.size}
                  isMsg={false}
                  key={key}
                />
                <AiFillCloseCircle
                  className="attachment-container-close-btn"
                  onClick={() => removeFile(key)}
                />
              </div>
            ))}
            {/* </div> */}
          </div>
        </div>
        <div className="message-bottom">
          <div className="conversation-icon">
            <label htmlFor="file">
              <CgAttachment className="conversation-icon" />
            </label>

            <input
              type="file"
              id="file"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e)}
              multiple
            />
          </div>
          <div className="message-send-btn" onClick={() => sendMessage()}>
            Send
          </div>
        </div>
      </div>
    </>
  );
}